/** Default page for academy trainings listing requests. */
export const ACADEMY_TRAININGS_LISTING_DEFAULT_PAGE = 1;

/** Default page size for academy trainings listing (UI + merged listing endpoint). */
export const ACADEMY_TRAININGS_LISTING_DEFAULT_PAGE_SIZE = 6;

/** Maximum number of items displayed (and fetched) by the trainings carousel. */
export const ACADEMY_TRAININGS_CAROUSEL_MAX_ITEMS = 10;

/** Maximum number of related trainings shown on the academy detail page. */
export const ACADEMY_RELATED_TRAININGS_MAX_ITEMS = 8;

/** Batch size when fetching all Docebo catalog items server-side for merging/sorting. */
export const ACADEMY_DOCEBO_CATALOG_FETCH_PAGE_SIZE = 100;
/** Safeguard in case of infinite loop */
export const ACADEMY_DOCEBO_CATALOG_MAX_PAGES = 100;

export const OPEN_STATES: DoceboCourseStatus[] = ['subscribed', 'in_progress'];
export const IN_PROGRESS_STATE: DoceboCourseStatus = 'in_progress';

const filterFields = [
    {
        name: 'trainingType',
        canonical: true
    },
    {
        name: 'bonusPoints',
        canonical: false
    },
    {
        name: 'learningFormat',
        canonical: true
    },
    {
        name: 'product',
        canonical: true
    },
    {
        name: 'status',
        canonical: false
    },
    {
        name: 'type',
        canonical: false
    }
] as const;

/** Fields that are canonicalized for the trainings listing. */
export const CANONICAL_FILTER_FIELDS = filterFields.filter((field) => field.canonical).map((field) => field.name);
/** Fields that are used for filtering the trainings listing. */
export const FILTER_FIELDS = filterFields.map((field) => field.name);

export const CATALOG_SORT_KEYS = ['createdAt', 'title', 'points', 'startsAt'] as const;

export const ACADEMY_REQUEST_TIMEOUT = 10_000;
